module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-8-4d24f4b976664e910e5a6ebe9102b5c8.png";